import React, { ChangeEvent, useRef, useState, useEffect } from "react";
import { OtpInput, OtpInputContainer } from "./otp.styles";

interface OtpFieldProps {
  size: number;
  onChange: (value: string) => any;
}
export const OtpField = ({ size, onChange }: OtpFieldProps) => {
  const [otpValues, setOtpValues] = useState(
    Array.from({ length: size }).map(() => "")
  );

  const otpInputs = useRef<HTMLInputElement[]>([]);

  const handleOtpChange = (index: number, value: string) => {
    const newValue = value.charAt(0);
    const updatedOtpValues = [...otpValues];
    updatedOtpValues[index] = newValue;
    setOtpValues(updatedOtpValues);
    if (newValue && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    } else if (!newValue && index > 0) {
      otpInputs.current[index - 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && index > 0 && !otpValues[index]) {
      event.preventDefault();
      const updatedOtpValues = [...otpValues];
      updatedOtpValues[index - 1] = "";
      setOtpValues(updatedOtpValues);
      otpInputs.current[index - 1].focus();
    }
  };
  useEffect(() => {
    onChange(otpValues.join(""));
  }, [otpValues]);
  return (
    <>
      <OtpInputContainer className="otpInput">
        {otpValues.map((value, index) => (
          <OtpInput
            key={index}
            value={value}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleOtpChange(index, e.target.value)
            }
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
              handleKeyDown(index, e)
            }
            type="text"
            maxLength={1}
            ref={(ref) => {
              if (ref) {
                otpInputs.current[index] = ref;
              }
            }}
          />
        ))}
      </OtpInputContainer>
    </>
  );
};
export default OtpField;
